import PageService from "@/services/PageService.js";

export default {
  namespaced: true,
  state: {
    privacyPolicy: null,
    termsOfUse: null,
    loading: false,
    errors: null,
    mechanics: null,
    overlayLoading: false
  },
  mutations: {
    SET_LOADING(state, value) {
      state.loading = value;
    },
    SET_OVERLAY_LOADING(state, overlayLoading) {
      state.overlayLoading = overlayLoading;
    },
    SET_ERRORS(state, errors) {
      state.errors = errors;
    },
    SET_PRIVACY_POLICY(state, privacyPolicy) {
      state.privacyPolicy = privacyPolicy;
    },
    SET_TERMS_OF_USE(state, termsOfUse) {
      state.termsOfUse = termsOfUse;
    },
    SET_MECHANICS(state, mechanics) {
      state.mechanics = mechanics;
    },
    RESET_ERRORS(state) {
      state.errors = null;
    }
  },
  getters: {
    privacyPolicy (state) {
      return state.privacyPolicy;
    },
    termsOfUse (state) {
      return state.termsOfUse;
    },
    overlayLoading (state) {
      return state.overlayLoading;
    }
  },
  actions: {
    async resetErrors({ commit }) {
      commit("RESET_ERRORS");
    },
    async getCustomerPages({ commit }, request) {
      commit("SET_LOADING", true);
      try {
        let { data } = await PageService.getCustomerPages(request);
        commit("SET_PRIVACY_POLICY", data.privacy_policy);
        commit("SET_TERMS_OF_USE", data.terms_use);
        commit("SET_LOADING", false);
      } catch (errors) {
        commit("SET_ERRORS", errors);
        commit("SET_LOADING", false);
      }
    },
    async getMechanics({ commit }, request) {
      commit("SET_LOADING", true);
      try {
        let data  = await PageService.getMerchantMechanics(request);
        commit("SET_MECHANICS", data.guideline);
        commit("SET_LOADING", false);
      } catch (errors) {
        commit("SET_ERRORS", errors);
        commit("SET_LOADING", false);
      }
    }
  }
};
